import { render, staticRenderFns } from "./DisplaceStatus.vue?vue&type=template&id=54fc0554"
import script from "./DisplaceStatus.vue?vue&type=script&lang=js"
export * from "./DisplaceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports